__turbopack_context__.v({
  "container": "ProductConfigureForm-module-scss-module__-vyLsG__container",
});
